
    <!-- ======================= Page Body ========================== -->
    <div class="container page-top-gap">
      <div class="row">
        <div class="col-lg-12">
          <div class="card page-body"> 
            
            <!--Top Info-->
            <div class="layout-container">
              <div class="layout-col p-t-5 p-r-15"><span class="icon amex-info-1 icon-size-l"></span></div>
              <div class="layout-col white-space-wrap">
                <h3 class="heading-3" i18n="@@TellUsAboutYourself">TellUsAboutYourself</h3>
              </div>
            </div>
            <hr/>
            <!--Top Info--> 
            
            <!-- ================ Form ================ -->
            
            <div class="m-t-30">
              <form action="#" [formGroup]="recommendationsFormGroup">
                <div class="outer-blue-box">
                  <div class="m-auto flex-single-column p-t-20">

                    <!-- ========= Form Row ========= -->
                    <div class="row">
                      <div class="col-md-12 col-sm-12">
                        <div class="form-group">
                          <div class="layout-container">
                            <div class="layout-col p-r-40">
                              <label class="control-label" i18n="@@WhatIsYourNationality">WhatIsYourNationality</label>
                            </div>
                            <div class="layout-col full-width">

                              <!--	Button Set  -->
                              <div class="layout-col btn-toggle-gap btn-gap">
                                <button class="btn btn-secondary" [ngClass]="{'btn-selected' : sharingDataService.minimumPaymtCalSharedData.Nationality == true}" (click)="setSaudi()" i18n="@@Saudi">Saudi</button>
                              </div>
                              <div class="layout-col">
                                <button class="btn btn-secondary" [ngClass]="{'btn-selected' : sharingDataService.minimumPaymtCalSharedData.Nationality == false}" (click)="setNonSaudi()" i18n="@@NotSaudi">NotSaudi</button>
                              </div>
                              <!--	/Button Set  -->

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- ========= /Form Row ========= -->
                    <!-- ========= Form Row ========= -->
                    <div class="row">
                      <div class="col-md-12 col-sm-12">
                        <div class="form-group">
                          <div class="layout-container">
                            <div class="layout-col p-r-40 v-align-top white-space-wrap">
                              <label class="control-label"><ng-container i18n="@@WhatIsYourMonthlyTakeHomeIncome1">WhatIsYourMonthlyTakeHomeIncome1</ng-container><br /><ng-container i18n="@@WhatIsYourMonthlyTakeHomeIncome2">WhatIsYourMonthlyTakeHomeIncome2</ng-container></label>
                            </div>
                            <div class="layout-col full-width">
                              <input formControlName="NetIncomeTxBx" (blue)="NetIncomeTxBx_Blur($event)" type="text" class="form-control" />
                              <div *ngIf="(submitted || recommendationsFormGroup.controls.NetIncomeTxBx.touched || recommendationsFormGroup.controls.NetIncomeTxBx.dirty) && recommendationsFormGroup.controls.NetIncomeTxBx.errors"
                                   class="msg-error">
                                <div *ngIf="recommendationsFormGroup.controls.NetIncomeTxBx.errors.required" i18n="@@PleaseEnterMonthlyIncome">
                                  PleaseEnterMonthlyIncome
                                </div>
                                <div *ngIf="recommendationsFormGroup.controls.NetIncomeTxBx.errors.lessThanMin" i18n="@@ShouldNotLessIncome">
                                  ShouldNotLessIncome
                                </div>
                                <div *ngIf="recommendationsFormGroup.controls.NetIncomeTxBx.errors.moreThanMax" i18n="@@ShouldNotMoreIncome">
                                  ShouldNotMoreIncome
                                </div>
                                <div *ngIf="recommendationsFormGroup.controls.NetIncomeTxBx.errors.invalidcurrency" i18n="@@IncomeContainsNonNumerics">
                                  IncomeContainsNonNumerics
                                </div>
                              </div>                             
                            </div>
                            <div class="layout-col v-align-middle usd-top-gap">
                              <span class="label-1 p-l-20">SAR</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- ========= /Form Row ========= -->
                    <!-- ========= Form Row ========= -->
                    <div class="row">
                      <div class="col-md-12 col-sm-12">
                        <div class="form-group">
                          <div class="layout-container">
                            <div class="layout-col p-r-40">
                              <label class="control-label"></label>
                            </div>
                            <div class="layout-col full-width">
                              <button class="btn btn-primary btn-next pos-relative" (click)="proceed()" [disabled]="recommendationsFormGroup.invalid">
                                <span i18n="@@GenericProceedBtn">GenericProceedBtn</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- ========= /Form Row ========= -->

                  </div>
                  <hr />
                  <div class="layout-col text-footnote" i18n="@@RecommendationTermsAndConditions">
                    RecommendationTermsAndConditions
                  </div>
                </div>
              </form>
            </div>
            
            <!-- ================ /Form ================ --> 
            
          </div>
        </div>
      </div>
    </div>
    <!-- ======================= /Page Body ========================== --> 
    
